module.exports = __webpack_public_path__ + "img/image10.812136fe.jpg";